/* Fabric Alex product page v4 — mobile PDP polish and interaction. */
(function () {
  var body = document.body;
  if (!body || !body.classList.contains('template-product')) return;

  body.classList.add('fa-product-v2-ready');
  var touchProduct = window.matchMedia('(max-width: 800px), (pointer: coarse)').matches;

  function injectPolishStyles() {
    if (document.getElementById('fa-product-page-v4-overrides')) return;

    var style = document.createElement('style');
    style.id = 'fa-product-page-v4-overrides';
    style.textContent = [
      '@media screen and (max-width: 740px) {',
      '  .template-product.fa-product-v2-ready .product-meta__reference { display: none !important; }',
      '  .template-product.fa-product-v2-ready .fa-pdp-meta-row { display:flex!important; width:100%!important; min-height:28px!important; align-items:center!important; justify-content:space-between!important; gap:12px!important; margin-top:10px!important; }',
      '  .template-product.fa-product-v2-ready .fa-pdp-meta-row .product-meta__reviews-badge { position:static!important; display:inline-flex!important; width:auto!important; min-width:0!important; align-items:center!important; margin:0!important; padding:0!important; border:0!important; background:transparent!important; box-shadow:none!important; }',
      '  .template-product.fa-product-v2-ready .fa-pdp-meta-row .fa-pdp-sku { display:inline-flex!important; align-items:center!important; flex:0 0 auto!important; margin:0 0 0 auto!important; color:rgba(19,44,68,.52)!important; font-size:.68rem!important; font-weight:750!important; letter-spacing:.035em!important; line-height:1.2!important; white-space:nowrap!important; }',
      '  .template-product.fa-product-v2-ready .fa-pdp-meta-row .fa-pdp-sku[hidden] { display:none!important; }',
      '  .template-product.fa-product-v2-ready .fa-pdp-gallery-reviews { position:static!important; display:inline-flex!important; margin:0!important; padding:0!important; border:0!important; background:transparent!important; box-shadow:none!important; -webkit-backdrop-filter:none!important; backdrop-filter:none!important; }',
      '',
      '  .template-product.fa-product-v2-ready .product-gallery--with-thumbnails > .scroller, .template-product.fa-product-v2-ready .product-gallery > .scroller { display:block!important; width:100%!important; margin-top:9px!important; padding-top:9px!important; border-top:1px solid rgba(19,44,68,.10)!important; overflow:visible!important; }',
      '  .template-product.fa-product-v2-ready .product-gallery > .scroller .scroller__inner { margin:0!important; padding:0 1px!important; }',
      '  .template-product.fa-product-v2-ready .product-gallery__thumbnail-list { position:static!important; display:flex!important; width:100%!important; max-height:none!important; flex-direction:row!important; flex-wrap:nowrap!important; align-items:center!important; gap:8px!important; margin:0!important; padding:3px 20px 5px 3px!important; overflow-x:auto!important; overflow-y:hidden!important; transform:none!important; scroll-snap-type:x proximity!important; scrollbar-width:none!important; -webkit-overflow-scrolling:touch!important; }',
      '  .template-product.fa-product-v2-ready .product-gallery__thumbnail-list::-webkit-scrollbar { display:none!important; }',
      '  .template-product.fa-product-v2-ready .product-gallery__thumbnail { position:relative!important; display:block!important; flex:0 0 62px!important; width:62px!important; height:62px!important; margin:0!important; padding:0!important; overflow:hidden!important; border:1px solid rgba(19,44,68,.15)!important; border-radius:10px!important; background:#f3f0eb!important; opacity:.68!important; scroll-snap-align:start!important; transition:opacity .16s ease,transform .16s ease,box-shadow .16s ease!important; }',
      '  .template-product.fa-product-v2-ready .product-gallery__thumbnail.is-filtered { display:none!important; }',
      '  .template-product.fa-product-v2-ready .product-gallery__thumbnail.is-nav-selected { opacity:1!important; transform:translateY(-1px)!important; box-shadow:0 0 0 2px #fff,0 0 0 4px #0b3155!important; }',
      '  .template-product.fa-product-v2-ready .product-gallery__thumbnail::after { display:none!important; }',
      '  .template-product.fa-product-v2-ready .product-gallery__thumbnail .fa-product-gallery__thumbnail-media, .template-product.fa-product-v2-ready .product-gallery__thumbnail .aspect-ratio { width:100%!important; height:100%!important; padding-bottom:0!important; }',
      '  .template-product.fa-product-v2-ready .product-gallery__thumbnail img { position:static!important; display:block!important; width:100%!important; height:100%!important; max-width:none!important; object-fit:cover!important; }',
      '',
      '  .template-product.fa-product-v2-ready .product-form__info-item--price .price-list { column-gap:5px!important; }',
      '  .template-product.fa-product-v2-ready .product-form__info-item--price .price { margin-left:0!important; margin-right:0!important; }',
      '  .template-product.fa-product-v2-ready .product-form__info-item--price .fa-product-price-unit { margin-left:-1px!important; }',
      '  .template-product.fa-product-v2-ready .product-form__info-item--price .price--compare { margin-left:2px!important; }',
      '',
      '  .template-product.fa-product-v2-ready .product-form__info-item--quantity .fa-quantity-native-select { position:absolute!important; width:1px!important; height:1px!important; margin:-1px!important; padding:0!important; overflow:hidden!important; clip:rect(0 0 0 0)!important; clip-path:inset(50%)!important; white-space:nowrap!important; border:0!important; opacity:0!important; pointer-events:none!important; }',
      '  .template-product.fa-product-v2-ready .fa-quantity-selector { display:grid!important; grid-template-columns:42px 58px 42px!important; align-items:stretch!important; height:46px!important; overflow:hidden!important; border:1px solid rgba(19,44,68,.20)!important; border-radius:11px!important; background:#fff!important; box-shadow:0 3px 10px rgba(8,39,67,.045)!important; }',
      '  .template-product.fa-product-v2-ready .fa-quantity-selector__button { display:flex!important; align-items:center!important; justify-content:center!important; width:42px!important; height:44px!important; margin:0!important; padding:0!important; border:0!important; background:rgba(11,49,85,.035)!important; color:#0b3155!important; font:inherit!important; font-size:1.32rem!important; font-weight:500!important; line-height:1!important; cursor:pointer!important; -webkit-tap-highlight-color:transparent!important; }',
      '  .template-product.fa-product-v2-ready .fa-quantity-selector__button:first-child { border-right:1px solid rgba(19,44,68,.11)!important; }',
      '  .template-product.fa-product-v2-ready .fa-quantity-selector__button:last-child { border-left:1px solid rgba(19,44,68,.11)!important; }',
      '  .template-product.fa-product-v2-ready .fa-quantity-selector__button:active { background:rgba(11,49,85,.10)!important; }',
      '  .template-product.fa-product-v2-ready .fa-quantity-selector__button:disabled { opacity:.30!important; cursor:default!important; }',
      '  .template-product.fa-product-v2-ready .fa-quantity-selector__input { width:58px!important; min-width:0!important; height:44px!important; margin:0!important; padding:0 3px!important; border:0!important; border-radius:0!important; outline:0!important; background:#fff!important; color:#132c44!important; -moz-appearance:textfield!important; appearance:textfield!important; font:inherit!important; font-size:1rem!important; font-weight:850!important; line-height:44px!important; text-align:center!important; }',
      '  .template-product.fa-product-v2-ready .fa-quantity-selector__input:focus { box-shadow:inset 0 0 0 2px rgba(11,49,85,.18)!important; }',
      '  .template-product.fa-product-v2-ready .fa-quantity-selector__input::-webkit-outer-spin-button, .template-product.fa-product-v2-ready .fa-quantity-selector__input::-webkit-inner-spin-button { margin:0!important; -webkit-appearance:none!important; }',
      '}',
      '@media (prefers-reduced-motion:reduce) { .template-product.fa-product-v2-ready .product-gallery__thumbnail { transition:none!important; } }'
    ].join('\n');

    document.head.appendChild(style);
  }

  function preflight(section) {
    if (!section || !touchProduct) return;

    var rawSettings = section.getAttribute('data-section-settings');
    if (rawSettings) {
      try {
        var settings = JSON.parse(rawSettings);
        settings.enableImageZoom = false;
        settings.infoOverflowScroll = false;
        section.setAttribute('data-section-settings', JSON.stringify(settings));
      } catch (error) {
        /* Leave native behaviour intact if a third-party app changes this JSON. */
      }
    }

    Array.prototype.forEach.call(section.querySelectorAll('.product-gallery__carousel--zoomable'), function (carousel) {
      carousel.classList.remove('product-gallery__carousel--zoomable');
    });

    Array.prototype.forEach.call(section.querySelectorAll('[data-zoom]'), function (image) {
      image.removeAttribute('data-zoom');
    });

    Array.prototype.forEach.call(section.querySelectorAll('.product-gallery__zoom-notice, .product__zoom-wrapper'), function (element) {
      element.remove();
    });
  }

  function arrangeMetaRow(section, meta) {
    if (!section || !meta || !touchProduct) return;

    var row = meta.querySelector('.fa-pdp-meta-row');
    if (!row) {
      row = document.createElement('div');
      row.className = 'fa-pdp-meta-row';
      var title = meta.querySelector('.product-meta__title');

      if (title && title.nextSibling) title.parentNode.insertBefore(row, title.nextSibling);
      else meta.appendChild(row);
    }

    var reviews = meta.querySelector('.product-meta__reviews-badge') || section.querySelector('.fa-pdp-gallery-reviews');
    if (reviews) {
      reviews.classList.remove('fa-pdp-gallery-reviews');
      row.appendChild(reviews);
    }

    var reference = meta.querySelector('.product-meta__reference');
    var sku = meta.querySelector('.product-meta__sku') || (reference ? reference.querySelector('.product-meta__sku') : null);
    if (sku) {
      sku.classList.add('fa-pdp-sku');
      var skuNumber = sku.querySelector('.product-meta__sku-number');
      sku.hidden = !!skuNumber && !(skuNumber.textContent || '').trim();
      row.appendChild(sku);
    }

    row.hidden = !row.children.length;
  }

  function arrangeHero(section) {
    if (!section || !touchProduct) return;

    var galleryWrapper = section.querySelector('.product-gallery__carousel-wrapper');
    var meta = section.querySelector('.product-meta');
    if (!galleryWrapper || !meta) return;

    section.classList.add('fa-pdp-has-gallery');

    var labels = meta.querySelector('.product-meta__label-list') || galleryWrapper.querySelector('.fa-pdp-gallery-sale');
    if (labels) {
      labels.classList.add('fa-pdp-gallery-sale');
      if (labels.parentNode !== galleryWrapper) galleryWrapper.appendChild(labels);
    }

    arrangeMetaRow(section, meta);
  }

  function localizeLegacyQuantity(root) {
    var isBulgarian = (document.documentElement.lang || '').toLowerCase().indexOf('bg') === 0;
    var labels = root.querySelectorAll('.product-form__info-item--quantity .product-form__info-content > span[style*="margin-left"], .product-form__info-item--quantity .fa-product-quantity-unit');

    Array.prototype.forEach.call(labels, function (label) {
      var text = (label.textContent || '').trim();
      if (!/metre\(s\)|meter|metre|^m$|^м$/i.test(text)) return;
      label.classList.add('fa-product-quantity-unit');
      label.removeAttribute('style');
      label.textContent = isBulgarian ? 'м' : 'm';
    });
  }

  function setupQuantityStepper(section) {
    if (!section || !touchProduct) return;

    var isBulgarian = (document.documentElement.lang || '').toLowerCase().indexOf('bg') === 0;
    var items = section.querySelectorAll('.product-form__info-item--quantity:not(.fa-length-control)');

    Array.prototype.forEach.call(items, function (item) {
      var content = item.querySelector('.product-form__info-content');
      var select = item.querySelector('select[name="quantity"]');
      if (!content || !select) return;

      var selectWrapper = select.closest('.select-wrapper');
      if (selectWrapper) selectWrapper.classList.add('fa-quantity-native-select');
      else select.classList.add('fa-quantity-native-select');

      var stepper = content.querySelector('.fa-quantity-selector');
      var input;

      if (!stepper) {
        stepper = document.createElement('div');
        stepper.className = 'fa-quantity-selector';
        stepper.setAttribute('role', 'group');
        stepper.setAttribute('aria-label', isBulgarian ? 'Количество' : 'Quantity');

        var minus = document.createElement('button');
        minus.type = 'button';
        minus.className = 'fa-quantity-selector__button';
        minus.setAttribute('data-fa-qty-minus', '');
        minus.setAttribute('aria-label', isBulgarian ? 'Намали количеството' : 'Decrease quantity');
        minus.textContent = '−';

        input = document.createElement('input');
        input.type = 'number';
        input.className = 'fa-quantity-selector__input';
        input.setAttribute('data-fa-qty-input', '');
        input.setAttribute('inputmode', 'numeric');
        input.setAttribute('pattern', '[0-9]*');
        input.min = '1';
        input.step = '1';
        input.autocomplete = 'off';
        input.setAttribute('aria-label', isBulgarian ? 'Количество' : 'Quantity');

        var plus = document.createElement('button');
        plus.type = 'button';
        plus.className = 'fa-quantity-selector__button';
        plus.setAttribute('data-fa-qty-plus', '');
        plus.setAttribute('aria-label', isBulgarian ? 'Увеличи количеството' : 'Increase quantity');
        plus.textContent = '+';

        stepper.appendChild(minus);
        stepper.appendChild(input);
        stepper.appendChild(plus);

        if (selectWrapper) content.insertBefore(stepper, selectWrapper);
        else content.insertBefore(stepper, select);

        function normalizeQuantity(raw) {
          var parsed = parseInt(raw, 10);
          if (!isFinite(parsed) || parsed < 1) parsed = 1;
          return Math.min(parsed, 999);
        }

        function setNativeQuantity(value, dispatchEvents) {
          value = normalizeQuantity(value);
          var matchingOption = null;

          for (var index = 0; index < select.options.length; index += 1) {
            if (String(select.options[index].value) === String(value)) {
              matchingOption = select.options[index];
              break;
            }
          }

          if (!matchingOption) {
            matchingOption = document.createElement('option');
            matchingOption.value = String(value);
            matchingOption.textContent = String(value);
            matchingOption.setAttribute('data-fa-generated-quantity', '');
            select.appendChild(matchingOption);
          }

          select.value = String(value);
          input.value = String(value);
          minus.disabled = value <= 1;

          if (dispatchEvents) {
            select.dispatchEvent(new Event('input', { bubbles: true }));
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        minus.addEventListener('click', function () {
          setNativeQuantity(normalizeQuantity(input.value) - 1, true);
        });

        plus.addEventListener('click', function () {
          setNativeQuantity(normalizeQuantity(input.value) + 1, true);
        });

        input.addEventListener('input', function () {
          if (!input.value.trim()) return;
          setNativeQuantity(input.value, false);
        });

        input.addEventListener('change', function () {
          setNativeQuantity(input.value, true);
        });

        input.addEventListener('blur', function () {
          setNativeQuantity(input.value, true);
        });

        select.addEventListener('change', function () {
          var current = normalizeQuantity(select.value);
          if (input.value !== String(current)) input.value = String(current);
          minus.disabled = current <= 1;
        });

        stepper.__faSetQuantity = setNativeQuantity;
      } else {
        input = stepper.querySelector('[data-fa-qty-input]');
      }

      if (stepper.__faSetQuantity) stepper.__faSetQuantity(select.value || (input ? input.value : 1), false);
    });
  }

  function setupGalleryCounter(section) {
    var wrapper = section.querySelector('.product-gallery__carousel-wrapper');
    var carousel = section.querySelector('.product-gallery__carousel');
    if (!wrapper || !carousel) return;

    var counter = wrapper.querySelector('.fa-product-gallery-counter');
    if (!counter) {
      counter = document.createElement('span');
      counter.className = 'fa-product-gallery-counter';
      counter.setAttribute('aria-live', 'polite');
      wrapper.appendChild(counter);
    }

    function visibleItems() {
      return Array.prototype.filter.call(carousel.querySelectorAll('.product-gallery__carousel-item'), function (item) {
        return !item.classList.contains('is-filtered') && item.style.display !== 'none';
      });
    }

    function updateCounter() {
      var items = visibleItems();
      var selected = null;

      for (var index = 0; index < items.length; index += 1) {
        if (items[index].classList.contains('is-selected')) {
          selected = items[index];
          break;
        }
      }

      if (!selected && items.length) selected = items[0];
      var selectedIndex = Math.max(0, items.indexOf(selected));
      counter.textContent = (selectedIndex + 1) + ' / ' + items.length;
      counter.hidden = items.length < 2;
    }

    updateCounter();

    if (!carousel.__faProductCounterObserver) {
      var observer = new MutationObserver(updateCounter);
      observer.observe(carousel, { subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
      carousel.__faProductCounterObserver = observer;
    }
  }

  function setupThumbnailRail(section) {
    if (!section || !touchProduct) return;
    var list = section.querySelector('.product-gallery__thumbnail-list');
    if (!list) return;

    function revealSelected(animate) {
      var selected = list.querySelector('.product-gallery__thumbnail.is-nav-selected:not(.is-filtered)');
      if (!selected) return;

      var targetLeft = selected.offsetLeft - Math.max(0, (list.clientWidth - selected.offsetWidth) / 2);
      if (list.scrollTo) list.scrollTo({ left: Math.max(0, targetLeft), behavior: animate ? 'smooth' : 'auto' });
      else list.scrollLeft = Math.max(0, targetLeft);
    }

    if (!list.__faThumbnailObserver) {
      var observer = new MutationObserver(function (mutations) {
        var shouldReveal = false;
        for (var index = 0; index < mutations.length; index += 1) {
          if (mutations[index].type === 'attributes' && mutations[index].attributeName === 'class') {
            shouldReveal = true;
            break;
          }
        }

        if (shouldReveal) window.requestAnimationFrame(function () { revealSelected(true); });
      });

      observer.observe(list, { subtree: true, attributes: true, attributeFilter: ['class'] });
      list.__faThumbnailObserver = observer;
    }

    window.requestAnimationFrame(function () { revealSelected(false); });
  }

  function enhance(section) {
    if (!section) return;
    arrangeHero(section);
    localizeLegacyQuantity(section);
    setupQuantityStepper(section);
    setupGalleryCounter(section);
    setupThumbnailRail(section);
  }

  function enhanceAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-section-type="product"]'), enhance);
  }

  injectPolishStyles();

  Array.prototype.forEach.call(document.querySelectorAll('[data-section-type="product"]'), function (section) {
    preflight(section);
    arrangeHero(section);
    localizeLegacyQuantity(section);
    setupQuantityStepper(section);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { window.setTimeout(enhanceAll, 0); });
  } else {
    window.setTimeout(enhanceAll, 0);
  }

  document.addEventListener('variant:changed', function () {
    window.setTimeout(function () {
      Array.prototype.forEach.call(document.querySelectorAll('[data-section-type="product"]'), function (section) {
        arrangeHero(section);
        localizeLegacyQuantity(section);
        setupQuantityStepper(section);
        setupGalleryCounter(section);
        setupThumbnailRail(section);
      });
    }, 20);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    var section = null;

    if (target && target.matches && target.matches('[data-section-type="product"]')) section = target;
    else if (target && target.querySelector) section = target.querySelector('[data-section-type="product"]');

    if (!section) return;
    preflight(section);
    window.setTimeout(function () { enhance(section); }, 0);
  });
})();